import React from "react";
import { Container, Row, Table } from "react-bootstrap";
import { useQuery } from "react-query";
import {
  carwashApi_getCustomers,
  carwashApi_getTransactions,
} from "../carwashApi";
import { TablePagination } from "../components/TableComponent/TablePagination.component";
import { DateTime } from "luxon";
import {
  ITransactionFilterForm,
  TransactionFilter,
} from "../components/transactionPages/TransactionFilter.component";
import pMap from "p-map";
import { MembershipUsageCount } from "../components/membershipPages/Component/MembershipUsageCount.component";

export const TransactionPage = () => {
  const [activePage, setActivePage] = React.useState(1);
  const [rowPerPage] = React.useState(10);
  const [filterData, setFilterData] = React.useState<ITransactionFilterForm>();
  const transactionQuery = useQuery(
    ["transactions", activePage, rowPerPage, filterData],
    async () => {
      const res = await carwashApi_getTransactions({
        limit: rowPerPage,
        skip: rowPerPage * (activePage - 1),
        transaction_date_max: filterData?.transaction_date_max
          ? DateTime.fromJSDate(filterData?.transaction_date_max)
              .set({ hour: 23, minute: 59, second: 59 })
              .toFormat("yyyy-MM-dd'T'HH:mm:ss")
          : undefined,
        transaction_date_min: filterData?.transaction_date_min
          ? DateTime.fromJSDate(filterData?.transaction_date_min)
              .set({ hour: 0, minute: 0, second: 0 })
              .toFormat("yyyy-MM-dd'T'HH:mm:ss")
          : undefined,
        "transaction_items.transaction_item_name":
          filterData?.transaction_items.transaction_item_name || undefined,
      });
      const dataTransaction = res.data;
      const dataTransactionWithMemberships = await pMap(
        dataTransaction.data,
        async (trx) => {
          const apiCustomerRes = await carwashApi_getCustomers({
            limit: "1",
            select: [
              "memberships",
              "memberships.cars",
              "memberships.membership_info_kartus",
            ],
            customer_id: trx.customer.customer_id,
          });
          trx.customer.memberships =
            apiCustomerRes.data.data[0].memberships?.filter(
              (m) => m.status === "active"
            );
          return trx;
        },
        { concurrency: 10 }
      );
      return {
        data: dataTransactionWithMemberships,
        count: dataTransaction.count,
      };
    },
    { retry: false }
  );
  return (
    <Container fluid>
      <TransactionFilter
        onFilter={(data) => {
          setFilterData({ ...data });
        }}
      />
      <Row style={{ paddingTop: "10px" }}>
        <h3>Total Data: {transactionQuery.data?.count || ""}</h3>
        <Table striped bordered>
          <thead>
            <tr>
              <th>Customer Name</th>
              <th>Customer Phone Number</th>
              <th>Used Plate Number</th>
              <th>Kartu</th>
              <th>Member Plate Number</th>
              <th>Transaction Item</th>
              <th>Transaction Date</th>
              <th>Amount</th>
              <th>Memberships</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {transactionQuery.data?.data.map((data) => (
              <tr>
                <td>{data.customer.customer_name}</td>
                <td>{data.customer.customer_phone_number}</td>
                <td>{data.car?.plate_number || ""}</td>
                <td>
                  {data.customer.memberships
                    ?.map((m) => m.membership_info_kartus)
                    .flat()
                    .filter((x) => !!x)
                    .sort(
                      (m1, m2) =>
                        DateTime.fromISO(m2!.created_at).toMillis() -
                        DateTime.fromISO(m1!.created_at).toMillis()
                    )
                    .map((kartu) => (
                      <Table key={kartu!.nomor_kartu}>
                        <tbody>
                          <tr>
                            <td>Nomor Kartu</td>
                            <td>{kartu!.nomor_kartu}</td>
                          </tr>
                        </tbody>
                      </Table>
                    ))}
                </td>
                <td>
                  {data.customer.memberships
                    ?.map((m) => m.cars)
                    .flat()
                    .filter((x) => !!x)
                    .map((car) => (
                      <Table key={car!.plate_number}>
                        <tbody>
                          <tr>
                            <td>{car!.plate_number}</td>
                          </tr>
                        </tbody>
                      </Table>
                    ))}
                </td>
                <td>
                  {data.transaction_items.map((transaction_item) => (
                    <Table key={transaction_item.id}>
                      <tbody>
                        <tr>
                          <td>Item Name</td>
                          <td>{transaction_item.transaction_item_name}</td>
                        </tr>
                        <tr>
                          <td>Item Price</td>
                          <td>{transaction_item.transaction_item_price}</td>
                        </tr>
                      </tbody>
                    </Table>
                  ))}
                </td>
                <td>
                  {DateTime.fromJSDate(
                    new Date(data.transaction_date)
                  ).toFormat("yyyy-MM-dd HH:mm:ss")}
                </td>
                <td>{data.transaction_amount}</td>
                <td>
                  {data.customer.memberships?.map((membership) => (
                    <Table key={membership.membership_id}>
                      <tbody>
                        <tr>
                          <td>Issue Date</td>
                          <td>
                            {DateTime.fromISO(membership.issue_date).toFormat(
                              "yyyy-MM-dd"
                            )}
                          </td>
                        </tr>
                        <tr>
                          <td>Expire Date</td>
                          <td>
                            {DateTime.fromISO(membership.expire_date).toFormat(
                              "yyyy-MM-dd"
                            )}
                          </td>
                        </tr>
                        <tr>
                          <td>Usage Count</td>
                          <td>
                            <MembershipUsageCount membership={membership} />
                          </td>
                        </tr>
                      </tbody>
                    </Table>
                  ))}
                </td>
                <td>{data.transaction_status}</td>
              </tr>
            ))}
          </tbody>
        </Table>
        <TablePagination
          total_page={Math.ceil(
            (transactionQuery.data?.count || 0) / rowPerPage
          )}
          // total_page={10}
          active_page={activePage}
          onClick={(page) => {
            setActivePage(page);
          }}
        />
      </Row>
    </Container>
  );
};
